export const Rows = {
    min: 3,
    max: 9,
};
